export default __webpack_public_path__ + "static/media/logo-set.3df99a16.svg";